var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"azcon-collection-card-skeleton"},[_c('div',{staticClass:"azcon-collection-card-skeleton__cover"}),_c('div',{staticClass:"azcon-collection-card-skeleton__name"})])
}]

export { render, staticRenderFns }